module.exports = __webpack_public_path__ + "img/view_temp_fd.4050150c.svg";